import React from 'react'
import { Typography } from '@mui/material'
import SparkLogo from '../../assets/sparklogo.svg'

const WelcomeBanner: React.FC = () => (
    <Typography variant="h2" align="center">
        Welcome to{' '}
        <img
            src={SparkLogo}
            alt="logo"
            style={{
                transform: 'translateY(15px)',
                height: '3.75rem',
                width: 'auto',
            }}
        />
    </Typography>
)

export default WelcomeBanner
